(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pnm-card-feedback"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.PNMCardFeedback) return;
  const configNode = document.querySelector('[data-pnm-cart-feedback-config]');
  if (!configNode) return;
  let labels;
  try { labels = JSON.parse(configNode.textContent); } catch (error) { return; }
  const tickets = new WeakMap();

  function restore(ticket) {
    const { button } = ticket;
    button.replaceChildren(...ticket.nodes.map(node => node.cloneNode(true)));
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.removeAttribute('data-pnm-cart-state');
  }

  function start(button) {
    const card = button.closest('.product-card.pnm-card[data-product-card]');
    if (!card) return null;
    const previous = tickets.get(button);
    if (button.disabled || previous?.state === 'adding') return false;
    if (previous) {
      clearTimeout(previous.timer);
      restore(previous);
    }
    const form = button.closest('form');
    const variantId = form?.querySelector('[name="id"]')?.value;
    let message = card.querySelector('[data-pnm-cart-message]');
    if (!message) {
      message = document.createElement('p');
      message.className = 'pnm-cart-feedback-message';
      message.setAttribute('data-pnm-cart-message', '');
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      message.setAttribute('aria-atomic', 'true');
      card.querySelector('.product-actions').appendChild(message);
    }
    message.textContent = '';
    message.removeAttribute('data-state');
    const ticket = { button, card, message, variantId: String(variantId || ''),
      nodes: Array.from(button.childNodes).map(node => node.cloneNode(true)), state: 'adding' };
    tickets.set(button, ticket);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('data-pnm-cart-state', 'adding');
    card.setAttribute('data-pnm-cart-feedback', 'adding');
    button.textContent = labels.adding;
    return ticket;
  }

  function error(ticket, response) {
    if (!ticket || ticket.state !== 'adding') return;
    ticket.state = 'error';
    restore(ticket);
    ticket.card.setAttribute('data-pnm-cart-feedback', 'error');
    ticket.message.setAttribute('data-state', 'error');
    const description = response?.description;
    ticket.message.textContent = typeof description === 'string' && description.trim()
      ? description.trim() : labels.error;
  }

  function success(ticket, response) {
    if (!ticket || ticket.state !== 'adding') return;
    const items = Array.isArray(response?.items) ? response.items : [response];
    const confirmed = ticket.variantId && items.some(item => item &&
      String(item.variant_id || item.id) === ticket.variantId && Number(item.quantity) > 0);
    if (!confirmed || Number(response?.status) >= 400) {
      error(ticket);
      return;
    }
    ticket.state = 'added';
    ticket.button.disabled = false;
    ticket.button.removeAttribute('aria-busy');
    ticket.button.setAttribute('data-pnm-cart-state', 'added');
    ticket.card.setAttribute('data-pnm-cart-feedback', 'added');
    ticket.button.textContent = '✓ ' + labels.added;
    const title = ticket.card.querySelector('.product-title')?.textContent.trim() || '';
    ticket.message.textContent = labels.added_message.replace('__product__', title);
    ticket.timer = setTimeout(() => {
      if (tickets.get(ticket.button) !== ticket || ticket.state !== 'added') return;
      restore(ticket);
      ticket.card.removeAttribute('data-pnm-cart-feedback');
      ticket.message.textContent = '';
      tickets.delete(ticket.button);
    }, 4000);
  }

  window.PNMCardFeedback = { start, success, error };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-card-status"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.pnmCardStatusReady) return;
  window.pnmCardStatusReady = true;
  const cardSelector = '[data-pnm-card-status]';
  const configNode = document.querySelector('[data-pnm-fitment-config]');
  if (!configNode) return;
  let labels;
  try { labels = JSON.parse(configNode.textContent); } catch (error) { return; }
  let scheduled = false;

  function selectedBike() {
    const link = document.querySelector('[data-pnm-bike-parts]:not([hidden])');
    if (!link || !link.getAttribute('href')) return null;
    try {
      const url = new URL(link.getAttribute('href'), location.origin);
      if (url.origin !== location.origin) return null;
      const one = key => url.searchParams.getAll(key).length === 1 ? url.searchParams.get(key) : '';
      return { brand: one('gff_705339'), model: one('gff_705341'), year: one('gff_705342') };
    } catch (error) { return null; }
  }

  function fitmentState(tags, bike) {
    if (tags.includes('Universal/Custom') || tags.includes('Universal')) return 'universal';
    if (!bike) return '';
    if (!bike.model || !bike.brand) return 'choose_model_year';
    if (!/^\d{4}$/.test(bike.year || '')) return 'choose_year';
    const exactTag = bike.model + ' (' + bike.year + ')';
    return tags.includes(bike.brand) && tags.includes(exactTag) ? 'fits' : 'not_listed';
  }

  function updateCard(card, bike) {
    const badge = card.querySelector('[data-pnm-card-fitment]');
    if (!badge) return;
    const tags = (card.getAttribute('data-pnm-fit-tags') || '').split('||');
    const state = fitmentState(tags, bike);
    const key = [state, bike?.brand || '', bike?.model || '', bike?.year || ''].join('|');
    if (badge.dataset.pnmFitKey === key) return;
    badge.dataset.pnmFitKey = key;
    badge.dataset.fitState = state;
    badge.hidden = !state;
    badge.replaceChildren();
    badge.removeAttribute('title');
    badge.removeAttribute('aria-label');
    if (!state) return;
    const icon = document.createElement('span');
    icon.className = 'pnm-fit-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = state === 'fits' ? '✓' : state === 'not_listed' ? '−' : 'ⓘ';
    const text = document.createElement('span');
    text.className = 'pnm-fit-copy';
    const bikeName = bike ? bike.year + ' ' + bike.brand + ' ' + bike.model : '';
    if (state === 'fits') {
      const status = document.createElement('span');
      status.className = 'pnm-fit-label';
      status.textContent = labels.fits;
      const model = document.createElement('span');
      model.className = 'pnm-fit-bike';
      model.textContent = bikeName;
      text.append(status, model);
      badge.setAttribute('aria-label', labels.fits_full.replace('__bike__', bikeName));
    } else {
      text.textContent = labels[state].replace('__bike__', bikeName);
    }
    if (state === 'universal') {
      const note = document.createElement('span');
      note.className = 'pnm-fit-note';
      note.textContent = labels.confirm;
      text.appendChild(note);
    }
    if (state === 'fits' || state === 'not_listed') {
      badge.title = bike.brand + ' ' + bike.model + ' (' + bike.year + ')';
    }
    badge.append(icon, text);
  }

  function sync() {
    scheduled = false;
    const bike = selectedBike();
    document.querySelectorAll(cardSelector).forEach(card => updateCard(card, bike));
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(sync); }
  }
  function start() {
    sync();
    new MutationObserver(records => {
      if (records.some(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (!target || target.closest('[data-pnm-card-fitment]')) return false;
        if (target.closest('[data-pnm-bike-bar], [data-pnm-bike-parts]')) return true;
        if (record.type === 'attributes') return target.matches(cardSelector);
        return Array.from(record.addedNodes).some(node => node.nodeType === 1 &&
          (node.matches(cardSelector) || node.querySelector(cardSelector)));
      })) schedule();
    }).observe(document.body, { subtree: true, childList: true, attributes: true,
      attributeFilter: ['href', 'hidden', 'data-pnm-fit-tags'] });
    window.addEventListener('globoFilterRenderCompleted', schedule);
    window.addEventListener('pageshow', schedule);
    window.addEventListener('storage', event => {
      if (event.key === 'pnm_selected_bike_v1' || event.key === null) schedule();
    });
    document.addEventListener('shopify:section:load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-category-filter-style"] && !Shopify.designMode) return;
  try {
    (() => {
  const configNode = document.querySelector('[data-pnm-sort-config]');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const selector = '.sort-by-toggle, #globo-dropdown-sort_options';
  let scheduled = false;

  function repairLabel(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim() === 'most_relevant') {
        node.nodeValue = node.nodeValue.replace('most_relevant', config.relevance);
      }
    }
    if (element.getAttribute('aria-label') === 'most_relevant') {
      element.setAttribute('aria-label', config.relevance);
    }
  }

  function sync() {
    scheduled = false;
    document.querySelectorAll('.gf-filter-selection .sort-by').forEach(sort => {
      const button = sort.querySelector('.sort-by-toggle');
      const list = sort.querySelector('#globo-dropdown-sort_options');
      if (!button || !list) return;
      repairLabel(button);
      if (button.getAttribute('data-pnm-sort-label') !== config.label) {
        button.setAttribute('data-pnm-sort-label', config.label);
      }
      const current = button.textContent.trim();
      const label = config.label + ': ' + current;
      if (button.getAttribute('aria-labelledby') === button.id) button.removeAttribute('aria-labelledby');
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      list.querySelectorAll('[data-sort]').forEach(option => {
        repairLabel(option);
        const selected = option.textContent.trim() === current;
        if (option.classList.contains('pnm-sort-selected') !== selected) {
          option.classList.toggle('pnm-sort-selected', selected);
        }
        if (option.getAttribute('aria-selected') !== String(selected)) {
          option.setAttribute('aria-selected', String(selected));
        }
      });
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }

  function start() {
    sync();
    new MutationObserver(records => {
      if (records.some(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (target?.closest(selector)) return true;
        return Array.from(record.addedNodes || []).some(node =>
          node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
        );
      })) schedule();
    }).observe(document.body, {
      childList:true,
      characterData:true,
      subtree:true,
      attributes:true,
      attributeFilter:['aria-expanded', 'class']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-collection-model-search"] && !Shopify.designMode) return;
  try {
    (() => {
  const compact = value => value.toLowerCase().replace(/[^a-z0-9]/g, '');
  const initialize = () => document.querySelectorAll('[data-pnm-model-search]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const brand = compact(root.dataset.brand);
    const normalize = value => {
      let term = compact(value);
      if (term.startsWith(brand)) term = term.slice(brand.length);
      return term.replace(/parts$/, '');
    };
    const input = root.querySelector('input');
    const form = root.querySelector('[data-model-search-form]');
    const clear = root.querySelector('[data-model-search-clear]');
    const browse = root.querySelector('[data-model-search-browse]');
    const label = root.querySelector('[data-model-search-label]');
    const status = root.querySelector('[data-model-search-status]');
    const empty = root.querySelector('[data-model-search-empty]');
    const list = root.querySelector('.pnm-model-search__list');
    const links = [...list.querySelectorAll('[data-model-search-link]')].map(element => ({ element, term: normalize(element.dataset.modelLabel), family: normalize(element.dataset.modelFamily || '') }));
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    links.sort((a, b) => collator.compare(a.term, b.term));
    links.forEach(link => list.append(link.element));
    let searching = false;
    let wasOpen = false;
    const filter = () => {
      const term = normalize(input.value);
      if (term && !searching) wasOpen = browse.open;
      let count = 0;
      links.forEach(link => {
        const match = !term || link.term.includes(term) || link.family.includes(term);
        link.element.hidden = !match;
        if (match) count += 1;
      });
      clear.hidden = !input.value;
      empty.hidden = !term || count > 0;
      list.hidden = Boolean(term) && count === 0;
      status.textContent = term ? (count === 1 ? root.dataset.resultOne : root.dataset.resultMany.replace('999999', String(count))) : '';
      label.textContent = term ? label.dataset.results : label.dataset.default;
      if (term) browse.open = true;
      else if (searching) browse.open = wasOpen;
      searching = Boolean(term);
    };
    input.addEventListener('input', filter);
    input.addEventListener('search', filter);
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape' && input.value) {
        event.preventDefault(); input.value = ''; filter();
      }
    });
    clear.addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
    form.addEventListener('submit', event => {
      event.preventDefault(); filter(); browse.open = true;
      links.find(link => !link.element.hidden)?.element.querySelector('a').focus();
    });
    form.hidden = false;
    filter();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-collection-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = [...document.querySelectorAll('[data-pnm-nav]')];
    if (!roots.length) return;
    let closeTimer;
    const desktop = root => !root.closest('.site-nav-mobile') && window.innerWidth > 1024;
    const normalize = value => value.toLowerCase().replace(/[^a-z0-9]/g, '');
    function closeModels(root) {
      root.querySelectorAll('.pnm-model-panel').forEach(panel => { panel.hidden = true; });
      root.querySelectorAll('.pnm-family-toggle').forEach(button => button.setAttribute('aria-expanded', 'false'));
      root.querySelectorAll('.pnm-selected').forEach(row => row.classList.remove('pnm-selected'));
      root.querySelector('.pnm-nav-panel')?.classList.remove('pnm-models-open');
    }
    function close(root) {
      const panel = root.querySelector('.pnm-nav-panel');
      if (panel) panel.hidden = true;
      root.classList.remove('pnm-open');
      root.querySelector('.pnm-root-toggle')?.setAttribute('aria-expanded', 'false');
      closeModels(root);
    }
    function place(root) {
      const panel = root.querySelector('.pnm-nav-panel');
      if (!panel || !desktop(root)) return;
      panel.style.left = '0px';
      const group = root.closest('.pnm-nav-brand-group');
      const nav = root.closest('#site-nav');
      const lowerEdge = group ? group.getBoundingClientRect().bottom : nav.getBoundingClientRect().bottom;
      panel.style.top = `${lowerEdge - root.getBoundingClientRect().top}px`;
      root.style.setProperty('--pnm-hover-bridge', `${Math.max(0, lowerEdge - root.getBoundingClientRect().bottom) + 3}px`);
      const rect = panel.getBoundingClientRect();
      const shift = Math.min(0, document.documentElement.clientWidth - rect.right - 12);
      panel.style.left = `${Math.max(12 - rect.left, shift)}px`;
      panel.style.setProperty('--pnm-list-height', `${Math.max(120, Math.min(420, window.innerHeight - rect.top - 140))}px`);
    }
    function open(root) {
      clearTimeout(closeTimer);
      roots.filter(other => other !== root).forEach(close);
      const panel = root.querySelector('.pnm-nav-panel');
      if (!panel) return;
      panel.hidden = false;
      root.classList.add('pnm-open');
      root.querySelector('.pnm-root-toggle')?.setAttribute('aria-expanded', 'true');
      place(root);
    }
    function openModels(root, button) {
      const target = document.getElementById(button.getAttribute('aria-controls'));
      if (!target) return;
      closeModels(root);
      target.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      button.closest('.pnm-family-row').classList.add('pnm-selected');
      const panel = root.querySelector('.pnm-nav-panel');
      panel.classList.add('pnm-models-open');
      if (desktop(root)) {
        const panelRect = panel.getBoundingClientRect();
        const rowRect = button.getBoundingClientRect();
        target.style.left = panelRect.right + target.offsetWidth > document.documentElement.clientWidth - 12 ? `${-target.offsetWidth}px` : '100%';
        const available = window.innerHeight - 84;
        const top = Math.max(0, Math.min(rowRect.top - panelRect.top, available - panelRect.top - target.offsetHeight));
        target.style.top = `${top}px`;
      } else {
        target.querySelector('.pnm-model-back').focus();
      }
    }
    roots.forEach(root => {
      root.querySelector('.pnm-root-toggle')?.addEventListener('click', () => {
        if (!desktop(root) && root.classList.contains('pnm-open')) close(root); else open(root);
      });
      root.addEventListener('pointerenter', event => {
        if (desktop(root) && event.pointerType !== 'touch') open(root);
      });
      root.addEventListener('pointerleave', event => {
        if (desktop(root) && event.pointerType !== 'touch') closeTimer = setTimeout(() => close(root), 220);
      });
      root.querySelectorAll('.pnm-family-row').forEach(row => {
        const button = row.querySelector('.pnm-family-toggle');
        row.addEventListener('pointerenter', event => {
          if (!desktop(root) || event.pointerType === 'touch') return;
          if (button) openModels(root, button); else closeModels(root);
        });
        button?.addEventListener('click', event => {
          if (!desktop(root) && button.getAttribute('aria-expanded') === 'true') closeModels(root);
          else {
            openModels(root, button);
            if (desktop(root) && event.detail === 0) document.getElementById(button.getAttribute('aria-controls')).querySelector('a')?.focus();
          }
        });
      });
      root.querySelectorAll('.pnm-model-back').forEach(button => button.addEventListener('click', () => {
        const active = root.querySelector('.pnm-family-toggle[aria-expanded="true"]');
        closeModels(root);
        active?.focus();
      }));
      root.querySelector('.pnm-family-list')?.addEventListener('scroll', () => { if (desktop(root)) closeModels(root); });
      root.querySelector('.pnm-nav-search')?.addEventListener('input', event => {
        closeModels(root);
        const query = normalize(event.target.value);
        const rows = [...root.querySelectorAll('.pnm-family-row')];
        rows.forEach(row => { row.hidden = !normalize(row.dataset.search).includes(query); });
        root.querySelector('.pnm-no-results').hidden = rows.some(row => !row.hidden);
      });
      root.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        const active = root.querySelector('.pnm-family-toggle[aria-expanded="true"]');
        if (active) { closeModels(root); active.focus(); }
        else { close(root); root.querySelector('.pnm-root-toggle')?.focus(); }
      });
      root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) close(root); });
    });
    document.addEventListener('click', event => { if (!event.target.closest('[data-pnm-nav]')) roots.forEach(close); });
    window.addEventListener('resize', () => roots.forEach(close));
    const nav = roots[0].parentElement;
    new MutationObserver(() => roots.forEach(close)).observe(nav, { attributes:true, attributeFilter:['class'] });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-collection-year"] && !Shopify.designMode) return;
  try {
    (()=>{
  const template=document.getElementById('pnm-collection-year-template');
  if(!template)return;
  let scheduled=false,anchorRestored=false;
  const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(sync)}};
  const sync=()=>{
    scheduled=false;
    const api=window.PNMCollectionYear;
    const context=api?.context();
    const bike=context?.bike;
    const tree=document.getElementById('gf-tree');
    const category=tree?.querySelector('[data-filter-id="852978"]')||tree?.querySelector('[data-filter-id]');
    let panel=document.getElementById('pnm-collection-year');
    if(!context||!category){panel?.remove();return}
    if(!panel){
      panel=template.content.firstElementChild.cloneNode(true);
      const busy=()=>{
        panel.querySelectorAll('select').forEach(select=>select.disabled=true);
        panel.setAttribute('aria-busy','true');
        const hint=panel.querySelector('.pnm-collection-year__hint');
        hint.textContent=hint.dataset.loading;
      };
      panel.querySelector('#pnm-collection-model-select').addEventListener('change',event=>{
        if(window.PNMCollectionYear?.selectModel(event.currentTarget.value))busy();
      });
      panel.querySelector('#pnm-collection-year-select').addEventListener('change',event=>{
        if(window.PNMCollectionYear?.select(event.currentTarget.value))busy();
      });
    }
    if(category.previousElementSibling!==panel)category.before(panel);
    const signature=context.base+'|'+context.models.map(model=>model.key+':'+model.years.join(',')).join(';');
    const modelSelect=panel.querySelector('#pnm-collection-model-select');
    const yearSelect=panel.querySelector('#pnm-collection-year-select');
    if(panel.dataset.models!==signature){
      const placeholder=template.content.querySelector('#pnm-collection-model-select option').cloneNode(true);
      placeholder.disabled=true;
      modelSelect.replaceChildren(placeholder,...context.models.map(model=>new Option(model.modelDisplay||model.modelType,model.key)));
      panel.querySelector('[data-pnm-year-model]').textContent=context.label;
      panel.dataset.models=signature;
    }
    const yearSignature=(bike?.key||'')+'|'+(bike?.years||[]).join(',');
    if(panel.dataset.model!==yearSignature){
      const allYears=template.content.querySelector('#pnm-collection-year-select option').cloneNode(true);
      yearSelect.replaceChildren(allYears,...(bike?.years||[]).map(year=>new Option(year,year)));
      panel.dataset.model=yearSignature;
    }
    if(!panel.hasAttribute('aria-busy')){
      modelSelect.value=bike?.key||'';
      yearSelect.value=bike?.bikeYear||'';
      modelSelect.disabled=false;
      yearSelect.disabled=!bike;
      const hint=panel.querySelector('.pnm-collection-year__hint');
      hint.textContent=bike?template.content.querySelector('.pnm-collection-year__hint').textContent:hint.dataset.chooseModel;
    }
    panel.dataset.selected=String(Boolean(bike?.bikeYear));
    if(!anchorRestored&&location.hash==='#pnm-collection-year'){
      anchorRestored=true;
      requestAnimationFrame(()=>panel.scrollIntoView({block:'start',behavior:'instant'}));
    }
  };
  const start=()=>{
    sync();
    new MutationObserver(changes=>{
      if(changes.some(change=>Array.from(change.addedNodes).some(node=>node.nodeType===1&&(node.matches('#gf-tree,[data-filter-id]')||node.querySelector('#gf-tree,[data-filter-id]')))))schedule();
    }).observe(document.body,{childList:true,subtree:true});
  };
  window.addEventListener('pnm:bike-change',schedule);
  window.addEventListener('globoFilterRenderCompleted',schedule);
  window.addEventListener('popstate',schedule);
  window.addEventListener('pageshow',()=>{
    const panel=document.getElementById('pnm-collection-year');
    if(panel){panel.removeAttribute('aria-busy');panel.querySelectorAll('select').forEach(select=>select.disabled=false);panel.querySelector('.pnm-collection-year__hint').textContent=template.content.querySelector('.pnm-collection-year__hint').textContent}
    schedule();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-honda-model-directory"] && !Shopify.designMode) return;
  try {
    (() => {
  const normalize = value => value.toLowerCase().replace(/[^a-z0-9]/g, '').replace(/^honda/, '').replace(/parts$/, '');
  const initialize = scope => {
    scope.querySelectorAll('[data-honda-directory]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const search = root.querySelector('input');
      const form = root.querySelector('[data-directory-search]');
      const clear = root.querySelector('[data-directory-clear]');
      const browse = root.querySelector('[data-directory-browse]');
      const browseLabel = root.querySelector('[data-directory-browse-label]');
      const status = root.querySelector('[data-directory-status]');
      const empty = root.querySelector('[data-directory-empty]');
      const list = root.querySelector('.pnm-honda-directory__list');
      const links = [...root.querySelectorAll('[data-directory-link]')].map(element => ({ element, term: normalize(element.dataset.search), family: normalize(element.dataset.familySearch || '') }));
      const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
      links.sort((a, b) => collator.compare(a.term, b.term));
      links.forEach(link => list.append(link.element));
      let wasOpen = false;
      let searching = false;
      const filter = () => {
        const term = normalize(search.value);
        if (term && !searching) wasOpen = browse.open;
        let count = 0;
        links.forEach(link => {
          const match = !term || link.term.includes(term) || link.family.includes(term);
          link.element.hidden = !match;
          if (match) count += 1;
        });
        clear.hidden = !search.value;
        empty.hidden = !term || count > 0;
        list.hidden = Boolean(term) && count === 0;
        status.textContent = term ? (count === 1 ? root.dataset.resultOne : root.dataset.resultMany.replace('999999', String(count))) : '';
        browseLabel.textContent = term ? browseLabel.dataset.searchLabel : browseLabel.dataset.default;
        if (term) browse.open = true;
        else if (searching) browse.open = wasOpen;
        searching = Boolean(term);
      };
      search.addEventListener('input', filter);
      search.addEventListener('search', filter);
      search.addEventListener('keydown', event => {
        if (event.key === 'Escape' && search.value) {
          event.preventDefault();
          search.value = '';
          filter();
        }
      });
      clear.addEventListener('click', () => {
        search.value = '';
        filter();
        search.focus();
      });
      form.addEventListener('submit', event => {
        event.preventDefault();
        filter();
        browse.open = true;
        links.find(link => !link.element.hidden)?.element.querySelector('a').focus();
      });
      root.querySelector('[data-directory-controls]').hidden = false;
      const picker = root.querySelector('[data-pnm-bike-open]');
      picker.hidden = !document.querySelector('[data-pnm-bike-bar][data-model-types-ready="true"]');
      filter();
    });
  };
  const start = () => initialize(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-product-cards"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.pnmCardDetailsReady) return;
  window.pnmCardDetailsReady = true;

  const configNode = document.querySelector('[data-pnm-card-config]');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const cardSelector = '.product-card.pnm-card';
  const heartSelector = '.product_wishlist[data-icon-wishlist][data-product-handle]';
  let scheduled = false;
  let lastCurrency = '';

  function selectedCurrency() {
    try {
      const code = window.tms?.selectorApi?.currency?.code;
      if (/^[A-Z]{3}$/.test(code || '')) return code;
    } catch (error) {}
    return config.currency;
  }

  function syncCurrency() {
    const code = selectedCurrency();
    lastCurrency = code;
    document.querySelectorAll(cardSelector + ' .product-price[data-price]').forEach(price => {
      let label = price.querySelector('[data-pnm-card-currency]');
      if (!label) {
        label = document.createElement('span');
        label.className = 'pnm-card-currency notranslate';
        label.setAttribute('translate', 'no');
        label.setAttribute('data-pnm-card-currency', '');
        price.appendChild(label);
      }
      if (label.textContent !== code) label.textContent = code;
    });
  }

  function savedHandles() {
    try {
      const items = JSON.parse(localStorage.getItem('items') || '[]');
      return Array.isArray(items) ? new Set(items) : null;
    } catch (error) {
      return null;
    }
  }

  function syncHearts() {
    const saved = savedHandles();
    if (!saved) return;
    document.querySelectorAll(heartSelector).forEach(heart => {
      const active = saved.has(heart.getAttribute('data-product-handle'));
      if (heart.classList.contains('whislist-added') !== active) {
        heart.classList.toggle('whislist-added', active);
      }
      const pressed = String(active);
      if (heart.getAttribute('aria-pressed') !== pressed) heart.setAttribute('aria-pressed', pressed);
      if (heart.getAttribute('role') !== 'button') heart.setAttribute('role', 'button');
      const title = heart.closest('.product-card')?.querySelector('.product-title')?.textContent.trim() || '';
      const label = (active ? config.removeLabel : config.addLabel) + (title ? ': ' + title : '');
      if (heart.getAttribute('aria-label') !== label) heart.setAttribute('aria-label', label);
      if (heart.getAttribute('title') !== label) heart.setAttribute('title', label);
    });
  }

  function syncFooters() {
    const rowsByGrid = new Map();
    document.querySelectorAll(cardSelector).forEach(card => {
      const price = card.querySelector('.product-price[data-price]');
      if (!price) return;
      let purchase = price.closest('[data-pnm-card-purchase]');
      if (!purchase) {
        purchase = document.createElement('div');
        purchase.className = 'pnm-card-purchase';
        purchase.setAttribute('data-pnm-card-purchase', '');
        const inner = document.createElement('div');
        inner.className = 'pnm-card-purchase-inner';
        const savings = price.parentElement.querySelector('.product-price-savings');
        price.before(purchase);
        purchase.appendChild(inner);
        inner.appendChild(price);
        if (savings) inner.appendChild(savings);
      }
      if (!card.getClientRects().length) return;
      const item = card.parentElement;
      const grid = item.parentElement;
      const rowTop = item.offsetTop;
      if (!rowsByGrid.has(grid)) rowsByGrid.set(grid, []);
      const rows = rowsByGrid.get(grid);
      let row = rows.find(entry => Math.abs(entry.top - rowTop) < 2);
      if (!row) { row = { top: rowTop, cards: [], purchase: 0, actions: 0 }; rows.push(row); }
      const actions = card.querySelector(':scope > .product-actions');
      const purchaseHeight = purchase.firstElementChild.offsetHeight;
      const actionsHeight = actions ? Array.from(actions.children).reduce((total, child) => {
        const style = getComputedStyle(child);
        if (style.position === 'absolute' || style.display === 'none') return total;
        return total + child.offsetHeight + (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
      }, 0) : 0;
      row.cards.push(card);
      row.purchase = Math.max(row.purchase, purchaseHeight);
      row.actions = Math.max(row.actions, actionsHeight);
    });
    rowsByGrid.forEach(rows => rows.forEach(row => row.cards.forEach(card => {
      const heights = { '--pnm-card-purchase-height': row.purchase, '--pnm-card-actions-height': row.actions };
      Object.entries(heights).forEach(([name, height]) => {
        const value = height + 'px';
        if (card.style.getPropertyValue(name) !== value) card.style.setProperty(name, value);
      });
    })));
  }

  function sync() {
    scheduled = false;
    syncCurrency();
    syncHearts();
    syncFooters();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }

  function start() {
    sync();
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('globoFilterRenderCompleted', schedule);
    document.addEventListener('shopify:section:load', schedule);
    if (document.fonts) document.fonts.ready.then(schedule);
    new MutationObserver(records => {
      const relevant = records.some(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (!target || target.closest('[data-pnm-card-currency]')) return false;
        if (target === document.body || target.closest('.product-card, .ht-tms-selector')) return true;
        return Array.from(record.addedNodes || []).some(node =>
          node.nodeType === 1 && (node.matches('.product-card, .ht-tms-selector') ||
          node.querySelector('.product-card, .ht-tms-selector'))
        );
      });
      if (relevant) schedule();
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'data-value'] });

    window.addEventListener('storage', event => {
      if (event.key === 'items') schedule();
    });
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) schedule();
    });
    document.addEventListener('keydown', event => {
      const heart = event.target.closest(heartSelector);
      if (heart && event.key === ' ' && heart.tagName === 'A') {
        event.preventDefault();
        heart.click();
      }
    });
    setInterval(() => {
      if (!document.hidden && selectedCurrency() !== lastCurrency) syncCurrency();
    }, 1500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-readable-type"] && !Shopify.designMode) return;
  try {
    (() => {
  const cartCss = `
    .upcart-product-title, .upcart-product-title-link, .upcart-upsell-item-title { font-size:18px!important; line-height:1.4!important; }
    .upcart-item-price, .upcart-product-quantity-input, .upcart-upsell-item-price-row, .upcart-upsell-item-price { font-size:18px!important; line-height:1.35!important; }
    .upcart-announcement, .upcart-announcement p, .upcart-rewards-message, .upcart-rewards-message p { font-size:18px!important; line-height:1.4!important; }
    .upcart-rewards-tier-description { font-size:14px!important; line-height:1.35!important; }
    .upcart-rewards-tier:last-child .upcart-rewards-tier-description { width:110px; text-align:right; align-self:flex-end; }
    .upcart-upsells-title, .upcart-upsells-title p { font-size:18px!important; line-height:1.4!important; }
    .upcart-upsells-button { font-size:18px!important; line-height:1.3!important; min-height:44px!important; }
    .upcart-continue-shopping, .upcart-continue-shopping a { font-size:18px!important; line-height:1.4!important; }
    .upcart-checkout-button { font-size:18px!important; line-height:1.4!important; min-height:48px!important; }
  `;
  function applyCartType() {
    const root = document.getElementById('upCart')?.shadowRoot;
    if (!root) return false;
    if (!root.querySelector('[data-pnm-readable-cart]')) {
      const style = document.createElement('style');
      style.setAttribute('data-pnm-readable-cart', '');
      style.textContent = cartCss;
      root.appendChild(style);
    }
    return true;
  }
  if (applyCartType()) return;
  const observer = new MutationObserver(() => {
    if (applyCartType()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList:true, subtree:true });
  window.addEventListener('pagehide', () => observer.disconnect(), { once:true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-results-toolbar"] && !Shopify.designMode) return;
  try {
    (() => {
  const configNode = document.querySelector('[data-pnm-results-toolbar-config]');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const contextTemplate = document.querySelector('[data-pnm-results-context-template]');
  const selector = '.gf-controls-search-form,.gf-summary,.gf-filter-selection';
  let scheduled = false;
  const markPath = (node, root) => {
    for (let parent = node.parentElement; parent && parent !== root; parent = parent.parentElement) {
      parent.classList.add('pnm-results-toolbar__pass');
    }
  };
  function currentResultsBike() {
    const context = window.PNMCollectionYear?.context();
    const bike = context?.bike;
    if (!bike?.bikeYear || ![bike.target, bike.baseURL].includes(context.base)) return null;
    const tags = location.pathname.slice(context.base.length + 1).split('+');
    if (tags.some(tag => tag.toLowerCase() === 'universal')) return null;
    return bike;
  }
  function syncContext(page, actions, bike) {
    let status = page.querySelector('.pnm-results-context');
    if (!bike || !contextTemplate) {
      if (status) status.hidden = true;
      return;
    }
    if (!status) status = contextTemplate.content.firstElementChild.cloneNode(true);
    const label = status.querySelector('[data-pnm-results-context-label]');
    const value = status.querySelector('[data-pnm-results-context-bike]');
    const bikeText = bike.brand + ' ' + (bike.modelDisplay || bike.modelType) + ' (' + bike.bikeYear + ')';
    if (label.textContent !== config.showing) label.textContent = config.showing;
    if (value.textContent !== bikeText) value.textContent = bikeText;
    if (actions.previousElementSibling !== status) actions.before(status);
    status.hidden = false;
  }
  function sync() {
    scheduled = false;
    const bike = currentResultsBike();
    if (!bike) document.querySelectorAll('.pnm-results-context').forEach(status => { status.hidden = true; });
    document.querySelectorAll('.page-collections .gf-controls-search-form').forEach(search => {
      const page = search.closest('.page-content') || search.closest('.page-collections');
      const summary = page?.querySelector('.gf-summary');
      const selection = page?.querySelector('.gf-filter-selection');
      const actions = summary?.closest('.gf-actions');
      const input = search.querySelector('input:not([type="hidden"]):not([type="submit"]):not([type="button"])');
      if (!input) return;
      if (input.placeholder !== config.placeholder) input.placeholder = config.placeholder;
      if (input.getAttribute('aria-label') !== config.label) input.setAttribute('aria-label', config.label);
      input.setAttribute('enterkeyhint', 'search');
      search.querySelectorAll('svg,i').forEach(icon => {
        if (!icon.closest('button,a,[role="button"]')) icon.classList.add('pnm-search-decoration');
      });
      const submit = [...search.querySelectorAll('button,input[type="submit"]')].find(button => {
        const name = [button.className, button.getAttribute('aria-label'), button.textContent].join(' ');
        return button.type !== 'reset' && !/clear|reset/i.test(name);
      });
      if (submit) {
        submit.classList.add('pnm-search-submit');
        submit.classList.toggle('pnm-search-submit-text', Boolean(submit.textContent.trim()));
        search.classList.add('pnm-search-has-submit');
        if (!submit.getAttribute('aria-label') && !submit.textContent.trim()) submit.setAttribute('aria-label', config.submit);
      }
      if (!actions || !selection || !actions.contains(selection) || search.contains(actions)) return;
      const count = summary.closest('.gf-filter-trigger') || summary;
      if (!actions.contains(count)) return;
      if (!actions.contains(search)) actions.prepend(search);
      actions.classList.add('pnm-results-toolbar');
      actions.classList.toggle('pnm-toolbar-native-sort', Boolean(selection.querySelector('.sort-by-toggle')));
      count.classList.add('pnm-results-toolbar__count');
      markPath(search, actions);
      markPath(count, actions);
      markPath(selection, actions);
      syncContext(page, actions, bike);
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }
  function start() {
    sync();
    const page = document.querySelector('.page-collections');
    if (!page) return;
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) schedule();
    }).observe(page, {childList:true, subtree:true});
  }
  window.addEventListener('pnm:bike-change', schedule);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('globoFilterRenderCompleted', schedule);
  window.addEventListener('popstate', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-universal-category"] && !Shopify.designMode) return;
  try {
    (() => {
  const node = document.querySelector('[data-pnm-universal-config]');
  const template = document.querySelector('[data-pnm-universal-template]');
  if (!node || !template) return;
  const config = JSON.parse(node.textContent);
  const categories = config.categories.filter(Boolean);
  const panel = template.content.firstElementChild.cloneNode(true);
  const heading = panel.querySelector('h2');
  const note = panel.querySelector('p');
  const link = panel.querySelector('a');
  const caption = link.querySelector('span');
  const returnPanel = document.createElement('div');
  returnPanel.className = 'pnm-universal-return';
  returnPanel.hidden = true;
  const returnLink = link.cloneNode(true);
  const returnCaption = returnLink.querySelector('span');
  returnPanel.append(returnLink);
  const returnKey = 'pnm_universal_return_v1';
  const available = new Map();
  let scheduled = false, currentContext = null, settling;
  const pageNumber = url => Number(url.searchParams.get('page') || url.searchParams.get('gf_page') || 1);
  const relative = url => url.pathname + url.search;
  const bikeKey = url => ['gff_705339','gff_705341','gff_705342'].map(key => url.searchParams.get(key) || '').join('|');
  function safeURL(value) {
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin && /\/collections\/[^/]+/.test(url.pathname) ? url : null;
    } catch (_) { return null; }
  }
  function preview(url) {
    const id = new URL(location.href).searchParams.get('preview_theme_id');
    if (id) url.searchParams.set('preview_theme_id', id);
    return url;
  }
  function categoryFor(url) {
    const values = url.searchParams.getAll('gf_852978');
    if (values.length > 1) return null;
    const direct = categories.find(category => category.handle === config.handle);
    if (values.length === 1) {
      const selected = categories.find(category => !category.parent && category.label === values[0]);
      if (!selected) return null;
      return direct && (direct.parent === selected.label || direct.handle === selected.handle) ? direct : selected;
    }
    return direct || null;
  }
  function selectedBike() {
    const partsLink = [...document.querySelectorAll('[data-pnm-bike-parts]')].find(item => !item.hidden && item.getAttribute('href'));
    const url = partsLink && safeURL(partsLink.getAttribute('href'));
    if (!url?.searchParams.get('gff_705339') || !url.searchParams.get('gff_705341')) return null;
    const brand = url.searchParams.get('gff_705339');
    const model = url.searchParams.get('gff_705341');
    const year = url.searchParams.get('gff_705342');
    return {url, key:bikeKey(url), label:brand + ' ' + model + (year ? ' (' + year + ')' : '')};
  }
  function destination(category) {
    return preview(new URL(config.root.replace(/\/$/, '') + '/collections/' + category.handle + '/universal', location.origin));
  }
  function hasItems(category) {
    const cached = available.get(category.handle);
    if (cached !== undefined) return cached;
    available.set(category.handle, null);
    const url = destination(category);
    url.searchParams.set('view', 'pnm-universal-count');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    fetch(relative(url), {credentials:'same-origin', signal:controller.signal})
      .then(response => { if (!response.ok) throw new Error('Unavailable'); return response.json(); })
      .then(data => available.set(category.handle, data.universal === true && data.handle === category.handle && Number(data.count) > 0))
      .catch(() => available.set(category.handle, false))
      .finally(() => { clearTimeout(timeout); schedule(); });
    return null;
  }
  const visible = element => Boolean(element && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
  function finalResults(grid, page) {
    if (grid.getAttribute('aria-busy') === 'true') return false;
    const summary = page.querySelector('.gf-summary');
    if (!summary) return false;
    const numbers = (summary.textContent.match(/\d[\d,]*/g) || []).map(value => Number(value.replace(/,/g, '')));
    const total = numbers.at(-1);
    if (!Number.isFinite(total)) return false;
    const count = grid.querySelectorAll('[data-pnm-card-status]').length;
    const current = pageNumber(new URL(location.href));
    // Any visible forward page link takes precedence over counts during a re-render.
    const forward = [...page.querySelectorAll('a[href]')].some(anchor => {
      if (!visible(anchor) || grid.contains(anchor) || panel.contains(anchor)) return false;
      const url = safeURL(anchor.getAttribute('href'));
      return url && url.pathname === location.pathname && pageNumber(url) > current;
    });
    if (forward) return false;
    if (count === total) return true;
    // Numbered pagination: use the app's selected page size or explicit summary range.
    if (numbers.length >= 3 && numbers.at(-2) >= total && count > 0) return true;
    const size = Number(page.querySelector('.limit-by select')?.value);
    return Number.isInteger(current) && current > 1 && size > 0 && count > 0 && count <= size && (current - 1) * size + count >= total;
  }
  function returnURL(bike, category) {
    try {
      const saved = JSON.parse(sessionStorage.getItem(returnKey) || 'null');
      const url = saved && safeURL(saved.url);
      if (url && saved.bike === bike.key && saved.category === category.handle && bikeKey(url) === bike.key) return preview(url);
    } catch (_) { /* Storage can be disabled. The selected bike remains a valid fallback. */ }
    const url = new URL(bike.url);
    url.searchParams.set('gf_852978', category.parent || category.label);
    return preview(url);
  }
  function setText(element, text) { if (element.textContent !== text) element.textContent = text; }
  function sync() {
    scheduled = false;
    const page = document.querySelector('.page-collections .page-content');
    const grid = page?.querySelector('#gf-products');
    const url = new URL(location.href);
    const category = categoryFor(url);
    const bike = selectedBike();
    currentContext = null;
    returnPanel.hidden = true;
    if (!page || !grid || !category) { panel.hidden = true; return; }
    const label = category.label.toLowerCase();
    if (config.universal) {
      panel.classList.add('pnm-universal--browsing');
      setText(heading, config.text.browse.replace('[category]', label));
      setText(note, config.text.note);
      if (bike) {
        setText(caption, config.text.back.replace('[bike]', bike.label));
        link.href = relative(returnURL(bike, category));
        setText(returnCaption, caption.textContent);
        returnLink.href = link.href;
        if (page.lastElementChild !== returnPanel) page.append(returnPanel);
        returnPanel.hidden = false;
      }
      link.hidden = !bike;
      const toolbar = page.querySelector('.gf-actions') || grid;
      if (toolbar.previousElementSibling !== panel) toolbar.before(panel);
      panel.hidden = false;
      return;
    }
    // An actual model filter must be active, not just a previously saved bike.
    if (!bike || !url.searchParams.get('gff_705341') || bikeKey(url) !== bike.key || !finalResults(grid, page)) { panel.hidden = true; return; }
    if (hasItems(category) !== true) { panel.hidden = true; return; }
    setText(heading, config.text.heading);
    setText(note, config.text.note);
    setText(caption, config.text.button.replace('[category]', label));
    link.href = relative(destination(category));
    link.hidden = false;
    currentContext = {url:relative(url), bike:bike.key, category:category.handle};
    if (grid.nextElementSibling !== panel) grid.after(panel);
    panel.hidden = false;
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }
  function settle() {
    panel.hidden = true;
    returnPanel.hidden = true;
    clearTimeout(settling);
    settling = setTimeout(schedule, 250);
  }
  link.addEventListener('click', () => {
    if (currentContext) try { sessionStorage.setItem(returnKey, JSON.stringify(currentContext)); } catch (_) {}
  });
  function start() {
    const page = document.querySelector('.page-collections');
    if (!page) return;
    new MutationObserver(records => {
      if (records.some(record => !panel.contains(record.target) && !returnPanel.contains(record.target) && (record.type === 'characterData' || [...record.addedNodes, ...record.removedNodes].some(item => item !== panel && item !== returnPanel)))) settle();
    }).observe(page, {childList:true, subtree:true, characterData:true});
    page.addEventListener('change', settle);
    page.addEventListener('submit', settle);
    sync();
  }
  window.addEventListener('globoFilterRenderCompleted', settle);
  window.addEventListener('pnm:bike-change', schedule);
  window.addEventListener('popstate', settle);
  window.addEventListener('pageshow', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
